<template>
  <span class="user" v-if="isReady">
    <b-form-group class="select-user-minimum">
      <multiselect :id="id" :options="items" v-model="value"
                   :placeholder="$t('user.placeholder')"
                   :loading="searching" :searchable="true" :internal-search="false"
                   @search-change="searchUserMin" @input="onInput"
                   track-by="id" label="_label">
        <template slot="singleLabel" slot-scope="props">
          <span v-if="showUsername && props.option.username" class="mr-1">({{ props.option.username }})</span>
          <span v-if="props.option._label" class="mr-1">{{ props.option._label }}</span>
          <span v-if="showMail && props.option.mail">&lt;{{ props.option.mail }}&gt;</span>
        </template>
        <template slot="option" slot-scope="props">
          <span v-if="showUsername && props.option.username" class="mr-1">({{ props.option.username }})</span>
          <span v-if="props.option._label" class="mr-1">{{ props.option._label }}</span>
          <span v-if="showMail && props.option.mail">&lt;{{ props.option.mail }}&gt;</span>
        </template>
        <template slot="noOptions">{{ $t('user.search.hint') }}</template>
        <template slot="noResult" v-if="!items.length">{{ $t('user.search.empty.message') }}</template>
      </multiselect>
    </b-form-group>
  </span>
</template>

<script>
import _ from 'lodash'
import { _AppApiService } from '@/services/_appApi.service'
import Multiselect from 'vue-multiselect'

export default {
  name: 'SelectUserMin',
  components: {
    Multiselect
  },
  props: {
    id: {
      type: String,
      default: 'user'
    },
    userId: String,
    username: String,
    showUsername: Boolean,
    showMail: Boolean,
    state: Boolean
  },
  data: function () {
    return {
      searching: false,
      isReady: false,
      value: {},
      items: []
    }
  },
  computed: {
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    userId (n, o) {
      this.load()
    },
    // eslint-disable-next-line no-unused-vars
    username (n, o) {
      this.load()
    }
  },
  methods: {
    onInput (user) {
      this.value = user
      this.$emit('update:user-id', _.get(user, 'id'))
      this.$emit('update:username', _.get(user, 'username'))
    },
    searchUserMin: _.debounce(function (q) {
      if (q && q.length > 1) {
        this.searching = true
        new _AppApiService(this.$axios).list('searchUserMin', { q }).then((response) => {
          this.items = response.items
          this.searching = false
        })
      }
    }, 300),
    load () {
      if (this.userId || this.username) {
        new _AppApiService(this.$axios).list('searchUserMin', { q: this.userId || this.username }).then((response) => {
          this.items = response.items
          this.value = _.first(this.items) || {}
          this.isReady = true
        })
      } else {
        this.onInput({})
        this.isReady = true
      }
    }
  },
  beforeMount () {
    this.load()
  }
}
</script>
